import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { useNavStateSync } from '@/common/hooks/navState/useNavStateSync';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { McdFinTrendChart } from './McdFinTrendChart';

export const DispTrendsCard = ({ formValues }) => {

  const [isChart, setIsChart] = useNavStateSync('dispTrendIsChart', true);

  const dispTrendButtons = (
    <ToggleButtonGroup exclusive size="small" value={isChart} sx={{ width: 'fit-content' }} onChange={(event, value) => { setIsChart(value) }}>
      <ToggleButton value={true} aria-label="bold">
        Chart
      </ToggleButton>
      <ToggleButton value={false} aria-label="bold">
        Table
      </ToggleButton>
    </ToggleButtonGroup>
  );
  
  return (
    <DashboardCard title="Quarter Over Quarter Dispute Trends" buttons={dispTrendButtons} >
      <McdFinTrendChart formValues={formValues} isPaid={false} isChart={isChart} />
    </DashboardCard>
  )
}